<!--基本卡片类组件 纯文字卡片 view:12-->
<template>
    <div class="view3Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";


    export default {
        name: "View3",
        components: {},
        props: {

            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {


            };

        },
        mounted() {

        },
        methods: {

            onAsk(name,value) {
                this.$emit('on-ask',name,value)
            }
        }
    };
</script>
<style lang="less" scoped>
    .view3Wrapper {
        background: rgba(255, 255, 255, 1);
        box-shadow: -6px 0px 6px 0px rgba(0, 0, 0, 0.03);
        border-radius: .2rem .45rem .45rem .45rem;
        padding: .36rem .5rem;
        ::-webkit-scrollbar {
            display: none;
            width:0;height:0;
        }


    }

</style>
